const trips = {
  statuses: {
    new: 'Aguardando Frota',
    approved: 'Aceito',
    canceled: 'Recusado',
  },
  table: {
    floatingActions: {
      tooltips: {
        accept: 'Esta ação só está disponível para viagens com o status "Aguardando Frota".',
        decline: 'Esta ação só está disponível para viagens com o status "Aguardando Frota".',
      },
    },
    filters: {
      supplier: 'Flota',
    },
    statuses: {
      new: 'Aguardando Frota',
      approved: 'Aceito',
      canceled: 'Recusado',
    },
    headers: {
      supplier: 'Flota',
    },
    cells: {
      supplier: {
        none: 'No Flota',
      },
      actions: {
        approve: 'Aceitar',
        remove: 'Recusar',
      }
    },
  },
};

export default trips;
